import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetInventoryCategoriesMutation } from '../apis';
import type { InventoryCategoryQueryLinkerSchema } from '../schemas';

export function InventoryCategoriesSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<InventoryCategoryQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: InventoryCategoryQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink
          to="/settings/inventory-categories/$id"
          params={{ id: `${item.id}` }}
          state={{ naturalBack: true }}
        >
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => `${item.id}`}
      useApi={useGetInventoryCategoriesMutation}
      disabled={disabled}
    />
  );
}
